
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findCoursesByMonth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categories"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCoursesByMonth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categories"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"begin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"end"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSeries"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teiln_max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teiln_gast_max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registration_period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coursename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"placename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceinfo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onlinecomments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registeredPlayers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canRegister"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canRegisterError"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canUnRegister"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canUnRegisterError"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceFloat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payOnline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forceCoursePayment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payCoursefee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentSlot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showEntryList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coursesSeries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"First"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Last"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"begin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"end"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":929}};
    doc.loc.source = {"body":"query findCoursesByMonth($date: String!, $categories: String! ) {\n    findCoursesByMonth(input: {\n        date: $date, categories: $categories\n    }) {\n        courses {\n            id, \n            name,\n            pro,\n            begin,\n            end,\n            showContent,\n            category,\n            isSeries,\n            teiln_max,\n            teiln_gast_max,\n            registration_period,\n            coursename,\n            placename,\n            priceinfo,\n            onlinecomments,\n            registeredPlayers,\n            canRegister,\n            canRegisterError\n            canUnRegister,\n            canUnRegisterError,\n            price,\n            priceFloat,\n            payOnline,\n            showPrice,\n            forceCoursePayment,\n            payCoursefee,\n            currentSlot,\n            showEntryList,\n            coursesSeries { First, Last, name, begin, end }\n        }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["findCoursesByMonth"] = oneQuery(doc, "findCoursesByMonth");
        
